import dayjs from 'dayjs';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@rrexpress/core';

export type AwbHistoryProps = {
  data: ShipmentDetail;
  handlePreview: (fileName: string) => void;
};

export const AwbHistory = ({ data, handlePreview }: AwbHistoryProps) => (
  <Table className="!table">
    <TableHead>
      <TableRow>
        <TableCell>Tanggal</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Keterangan</TableCell>
        <TableCell>Lampiran</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {(data?.awb_histories || []).map((item, index: number) => (
        <TableRow>
          <TableCell>{dayjs(item.awb_item_history_date_time_utc).format('DD/MM/YYYY HH:mm')}</TableCell>
          <TableCell>{item.status_id}</TableCell>
          <TableCell>{item.status_external_name}</TableCell>
          <TableCell>{item?.attachments?.length > 0 ? <a onClick={() => handlePreview(item?.attachments?.[0].file_path)} className="block text-blue-500 cursor-pointer">Foto</a> : '-'}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
